import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { programRoutes } from '../../data/mock';

export default function ProgramRouteCards({ testIdPrefix = 'route-card' }) {
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {programRoutes.map((r, i) => (
        <Link
          key={r.id}
          to={r.to}
          data-testid={`${testIdPrefix}-${r.id}`}
          className="group flex flex-col rounded-3xl bg-white border border-splash-sand p-6 card-hover"
        >
          <div className="flex items-center justify-between">
            <span className="text-[11px] uppercase tracking-widest font-semibold text-splash-coral">{r.ages}</span>
            <span className="font-display font-bold text-splash-sand text-2xl">0{i + 1}</span>
          </div>
          <h3 className="mt-3 font-display font-bold text-2xl text-splash-green">{r.title}</h3>
          <p className="mt-2 text-sm text-splash-green/75 leading-relaxed flex-1">{r.blurb}</p>
          <div className="mt-5 flex items-end justify-between gap-2">
            <div>
              <span className="font-display font-bold text-2xl text-splash-green">{r.price}</span>
              <span className="ml-1 text-xs text-splash-green/65">{r.per}</span>
            </div>
            <span className="w-9 h-9 rounded-full bg-splash-teal text-white grid place-items-center group-hover:bg-splash-coral transition-colors">
              <ArrowRight className="w-4 h-4" />
            </span>
          </div>
        </Link>
      ))}
    </div>
  );
}
